import { FormatMessage } from '../../../../locale/hooks';

export default (formatMessage: FormatMessage) => ({
  loadingText: formatMessage('loading'),
  noOptionsText: formatMessage('noOptions'),
  clearText: formatMessage('clear'),
  closeText: formatMessage('close'),
  openText: formatMessage('open'),
});
